export default __webpack_public_path__ + "static/media/header.10a772ed.png";